import { Provider } from '@angular/core';
import { VIRTUAL_SCROLL_STRATEGY } from '@angular/cdk/scrolling';
import { MeasuredSizeVirtualScrollStrategy } from './measured-size-virtual-scroll-strategy';

/**
 * Providers for a viewport whose item heights are measured rather than assumed.
 *
 * Both tokens must resolve to one instance. CDK drives the strategy through
 * `VIRTUAL_SCROLL_STRATEGY`. The host component needs the concrete type to push item keys and to
 * invalidate heights. Provide the two separately and you get two instances: the one CDK holds never
 * receives any keys, and the list renders blank with no error.
 *
 * @param defaultItemSize Height used for items that have never been measured. It only affects the
 * first frame or two. After that the mean of the real measurements takes over.
 */
export function provideMeasuredVirtualScroll(defaultItemSize: number): Provider[] {
  return [
    {
      provide: MeasuredSizeVirtualScrollStrategy,
      useFactory: () => new MeasuredSizeVirtualScrollStrategy(defaultItemSize)
    },
    { provide: VIRTUAL_SCROLL_STRATEGY, useExisting: MeasuredSizeVirtualScrollStrategy }
  ];
}
